import { useContent } from "../data/siteContent";

export default function AnnouncementBar() {
  const { announcement } = useContent();
  if (!announcement?.enabled || !announcement.text?.trim()) return null;
  const inner = (
    <span className="text-[11px] uppercase tracking-[0.2em] text-white">{announcement.text}</span>
  );
  return (
    <div
      data-testid="announcement-bar"
      className="fixed inset-x-0 top-0 z-[70] flex h-9 items-center justify-center bg-myrtle px-4 text-center"
    >
      {announcement.link?.trim() ? (
        <a href={announcement.link} data-testid="announcement-link" className="transition-opacity duration-300 hover:opacity-80">
          {inner}
        </a>
      ) : (
        inner
      )}
    </div>
  );
}

export const useAnnouncementOffset = () => {
  const { announcement } = useContent();
  return announcement?.enabled && announcement.text?.trim() ? 36 : 0;
};
